import { withWindow } from '@shared/utils/withWindow';

export const performFullPageRedirect = (path: string) => {
  withWindow(global => {
    global.location.href = global.location.origin + path;
  });
};
